import styled from "@emotion/native";
import { Platform } from "react-native";
import Svg from "react-native-svg";
import Text from "../../components/Text";

export const Container = styled.View(
    {
        flex: 1,
    },
    ({ theme }: any) => {
        return {
            backgroundColor: theme.color.background,
        };
    },
);

export const Scroll = styled.ScrollView({
    flex: 1,
    overflow: Platform.OS === ("android" || "web") ? "scroll" : "visible",
});

Scroll.defaultProps = {
    contentContainerStyle: { flexGrow: 1 },
};

export const Content = styled.View({
    paddingBottom: 90,
});

export const Hero = styled.Image({
    resizeMode: "cover",
    width: "100%",
    height: 270,
});

export const Summary = styled(Text)({});

export const Snippets = styled.View({});

export const Ledge = styled(Svg)({
    marginTop: 32,
});

export const UpNext = styled(Text)({
    marginLeft: 12,
    marginBottom: 20,
});

export const Cta = styled.View({
    position: "absolute",
    width: "100%",
    bottom: 16,
});
export const RedoContainer = styled.View({
    alignSelf: "flex-end",
    marginRight: 30,
    marginTop: 20,
    height: 25,
    width: 80,
    zIndex: 10000,
    display: "flex",
    flexDirection: "row",
});

export const RedoText = styled(Text)({
    marginRight: 10,
    flexDirection: "row",
});

export const RestartContainer = styled.View({
    position: "relative",
    marginTop: -20,
});
